/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type AvatarNode_Node = {
    readonly __typename: "Group";
    readonly groupName: string | null;
    readonly " $refType": "AvatarNode_Node";
} | {
    readonly __typename: "Patient";
    readonly name: string | null;
    readonly oid_avatar: string | null;
    readonly isOnline: boolean | null;
    readonly " $refType": "AvatarNode_Node";
} | {
    readonly __typename: "Provider";
    readonly name: string | null;
    readonly oid_avatar: string | null;
    readonly isOnline: boolean | null;
    readonly " $refType": "AvatarNode_Node";
} | {
    readonly __typename: "User";
    readonly name: string | null;
    readonly oid_avatar: string | null;
    readonly isOnline: boolean | null;
    readonly " $refType": "AvatarNode_Node";
} | {
    readonly __typename: "ChatActivity";
    readonly patient: {
        readonly name: string | null;
        readonly oid_avatar: string | null;
        readonly isOnline: boolean | null;
    } | null;
    readonly " $refType": "AvatarNode_Node";
} | {
    /*This will never be '%other', but we need some
    value in case none of the concrete values match.*/
    readonly __typename: "%other";
    readonly " $refType": "AvatarNode_Node";
};
export type AvatarNode_Node$data = AvatarNode_Node;
export type AvatarNode_Node$key = {
    readonly " $data"?: AvatarNode_Node$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"AvatarNode_Node">;
};



const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "oid_avatar",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isOnline",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AvatarNode_Node",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "groupName",
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "type": "Group",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v0/*: any*/),
      "type": "Patient",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v0/*: any*/),
      "type": "Provider",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v0/*: any*/),
      "type": "User",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Patient",
          "kind": "LinkedField",
          "name": "patient",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        }
      ],
      "type": "ChatActivity",
      "abstractKey": null
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
})();
(node as any).hash = 'e88a41cd909e78b6848d3586d76e27c3';
export default node;
